/* ヘッダー内カテゴリメニューの複製 */
function duplicateCategoryMenu() {
  const categoryMenuElm = document.querySelector('#Details-menu-container .c-category-menu'),
        appendTarget = document.getElementById('categoryMenuWrap'),
        loading = appendTarget.querySelector('.loading-overlay__wrapper');
  if(categoryMenuElm && appendTarget) {
    const duplicatedMenu = categoryMenuElm.cloneNode(true);
    loading.classList.add('hidden');
    appendTarget.appendChild(duplicatedMenu);
  }
}

duplicateCategoryMenu();